/**
 * Turns an exported SVG file's text into markup that can be inlined inside a
 * wrapper `<svg>` the app controls.
 *
 * `stripStroke` is off by default: most icons want their file's own
 * attributes, and several mix filled and stroked paths, where handing the
 * stroke to the wrapper would outline the filled ones too.
 */
const INNER = /<svg\b[^>]*>([\s\S]*)<\/svg>/i;
const STROKE_ATTRS = /\s(?:stroke|stroke-width)="[^"]*"/g;

export const svgInner = (raw = '', { stripStroke = false } = {}) => {
  const body = String(raw).match(INNER)?.[1] ?? '';
  return (stripStroke ? body.replace(STROKE_ATTRS, '') : body).trim();
};

export default svgInner;
